import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Devis24h from "../../assets/icons/devis-sous-24_H.svg"
import Qualitegarantie from "../../assets/icons/qualite-garantie.svg"
import Echantillon from "../../assets/icons/echantillon.svg"
import Maquette from "../../assets/icons/maquette-virtuelle.svg"
import Livraison7 from "../../assets/icons/livraison.svg"
import LivraisonOfferte from "../../assets/icons/livraison-offerte.svg"
import France from "../../assets/icons/impression-francaise.svg"

const IconsLineCat = ({ iconsToSet = undefined }) => {

  const icons = iconsToSet || [
    {
      src: <Devis24h height="64" />,
      text: <>SU PRESUPUESTO <br/>EN 24H</>,
      alt: "SU PRESUPUESTO EN 24H",
    },
    {
      src: <Qualitegarantie height="64" />,
      text: <span>CONTROL <br />DE CALIDAD</span>,
      alt: "CONTROL DE CALIDAD",
    },
    {
      src: <Echantillon height="64" />,
      text: <span>ENVÍO DE EJEMPLO<br />POSSIBLE</span>,
      alt: "ENVÍO DE EJEMPLO POSSIBLE",
    },
    {
      src: <Maquette height="64" />,
      text: <span>MAQUETA<br />VIRTUAL</span>,
      alt: "MAQUETA VIRTUAL",
    },
    {
      src: <Livraison7 height="64" />,
      text: <span>FABRICADO Y ENVIADO<br />EN 10 DÍAS LABORABLES</span>,
      alt: "FABRICADO Y ENVIADO EN 10 DÍAS LABORABLES",
    },
    {
      src: <LivraisonOfferte height="64" />,
      text: <span>ENVÍO<br />GRATUITO</span>,
      alt: "ENVÍO GRATIS",
    },
    {
      src: <France height="64" />,
      text: <>IMPRESIÓN <br/>EUROPEA</>,
      alt: "IMPRESIÓN²EUROPEA",
    },
  ];

  return (
    <ul className={`hidden md:grid md:grid-cols-${icons.length} items-start list-none justify-between  `}>
      {icons
        .map((icon, i) => (
          <li key={i} className="">
            <div className="flex justify-center items-center mb-4">
              {(icon.src)}
            </div>
            <div className="mb-0 text-sm font-bold text-gray-700 text-center">{icon.text}</div>
          </li>
        ))}
    </ul>
  );
};


export default IconsLineCat;
